import React, { useState, useRef } from 'react';
import Select, { components } from 'react-select';
import { FormControl, InputLabel, FormHelperText, Box } from '@mui/material';
import { FiSearch } from 'react-icons/fi';
import dropdown from "../assets/svg/dropdown.svg";

const MuiSelectAndSearch = ({
  label = '',
  options = [],
  placeholder = 'Select an option',
  onChange,
  value,
  errorMessage,
  isDisable = false,
  editBoolean,
  hideClearIcon = false, // New prop to control clear icon visibility
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const selectRef = useRef();

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '32px',
      height: 'auto',
      borderRadius: '6px',
      fontFamily: 'Lato',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
      paddingBottom:"2.5px",
      textAlign: "start",
      borderColor: editBoolean
        ? 'orange !important'
        : errorMessage
          ? '#d40e10 !important'
          : provided.borderColor,
      '&:hover': {
        borderColor: editBoolean
          ? 'orange !important'
          : errorMessage
            ? '#d40e10 !important'
            : provided.borderColor,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 5px',
      height: '22px',
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'Lato',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
      color: '#0F1828',
    }),
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      backgroundColor: state.isSelected ? '#edf4fb' : 'white',
      color: 'black',
      fontFamily: 'Lato',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
      borderBottom: '1px solid #E3E7EF',
      '&:hover': {
        backgroundColor: '#f0f0f0',
      },
    }),
    menu: (provided) => ({
      ...provided,
      fontFamily: 'Mulish',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '18.2px',
      color: "#0F1828",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '0',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '22px',
      marginTop: "4px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '0 4px',
      display: 'flex',
      alignItems: 'center',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 4px',
      display: 'flex',
      alignItems: 'center',
    }),
    crossIcon: (provided) => ({
      ...provided,
      width: '14px',
      height: '14px',
    }),
    dropdownIndicatorSeparator: (provided) => ({
      ...provided,
      margin: '4px 0',
    }),
    indicatorSeparator: (provided) => ({
      display: 'none', // Hide the indicator separator
    }),
  };

  const Option = props => (
    <div
      ref={props.innerRef}
      {...props.innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: props.isSelected ? '#edf4fb' : 'white',
        color: 'black',
        fontFamily: 'Lato !important',
        fontSize: '12px !important',
        fontWeight: '400 !important',
        lineHeight: '16px !important',
        borderBottom: '1px solid #E3E7EF',
        padding: '8px 12px',
        cursor: 'pointer',
      }}
    >
      {props.data.name}
    </div>
  );

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <img src={dropdown} />
    </components.DropdownIndicator>
  );

  // Custom ClearIndicator component that conditionally renders based on hideClearIcon prop
  const ClearIndicator = (props) => {
    // Don't render the clear indicator if hideClearIcon is true
    if (hideClearIcon) {
      return null;
    }
    // Otherwise, render the default clear indicator
    return <components.ClearIndicator {...props} />;
  };

  // Custom MenuList to match the SearchableMultiSelect style
  const MenuList = props => (
    <components.MenuList {...props}>
      {props.children}
    </components.MenuList>
  );

  return (
    <FormControl
      sx={{ mt: '10px', width: '100%' }}
      variant="outlined"
      size="small"
      error={!!errorMessage}
    >
      <InputLabel shrink>{label}</InputLabel>
      <div ref={selectRef}>
        <Select
          options={options}
          value={value}
          onChange={handleChange}
          placeholder={
            <Box sx={{ display: "flex", alignItems: "center", color: "#9499a0ed" }}>
              <FiSearch style={{ color: "#858D9D", marginRight: '5px', height: "14px", width: "14px" }} />
              {placeholder}
            </Box>
          }
          isDisabled={isDisable}
          styles={customStyles}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
          components={{ 
            Option, 
            DropdownIndicator, 
            MenuList,
            ClearIndicator // Add the custom clear indicator component
          }}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          isClearable={!hideClearIcon} // Only set isClearable to true if hideClearIcon is false
        />
      </div>
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default MuiSelectAndSearch;